
import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";


export default class StudyBackgroundRequest extends MainRequest {


    static findCurrent(idPatient) {
        return this.postSEC(ServicePath.STUDY_BACKGROUND_CURRENT, {idPatient: idPatient});
    }
    
    static findBackgroundByStudy(idStudy) {
        return this.postSEC(ServicePath.STUDY_BACKGROUND_BY_STUDY, {idStudy});
    }


}